export default {"src":"/_next/static/media/fctlogo.860175d6.svg","height":70,"width":248,"blurWidth":0,"blurHeight":0};